import * as React from 'react'

import { Box, ItemListPad, Text } from '@factorialco/deprecated-design-system'

interface Props {
  title: string
  children: React.ReactNode
}

const ChartTooltip = ({ title, children }: Props) => {
  return (
    <Box borderRadius={{ all: 'abs008' }} overflowX="hidden" overflowY="hidden">
      <ItemListPad>
        <Box gap="s8">
          <Text capitalize size="200" weight="normal" color="grey100">
            {title}
          </Text>
          {children}
        </Box>
      </ItemListPad>
    </Box>
  )
}

export default ChartTooltip
